import { Injectable } from '@angular/core';
import { filterAllTruthyInTuple, subjectFromObs } from 'core/rx-js';
import { BehaviorSubject, Subject, combineLatest, filter, map, takeUntil } from 'rxjs';
import { IControl, SSFormControl, SSFormGroup } from './form-controls';


@Injectable({ providedIn: 'root' })
export class DynamicFormService {


  readonly formDataSubject = new BehaviorSubject<any>(null)
  get formData() {
    return this.formDataSubject.value
  }

  private readonly _destroy = new Subject<void>();
  showClearBtn?: boolean;

  readonly controlsSubject = new BehaviorSubject<IControl[]>([])
  get controls() {
    return this.controlsSubject.value
  }
  set controls(value) {
    this.controlsSubject.next(value)
  }

  //controls dep


  private _layout?: any;
  get layout() {
    return this._layout
  }
  set layout(value: any) {
    this._layout = value;
  }

  readonly initializedSubject = new BehaviorSubject<boolean>(false)

  readonly mainFormGroupSubject = subjectFromObs({
    observable: this.controlsSubject.pipe(
      filter(Boolean),
      map(controls => this._getMainFormGroup(controls))
    ),
    initialValue: new SSFormGroup({}),
    until: this._destroy
  })
  readonly submittedSubject = new BehaviorSubject<boolean>(false);

  readonly numberOfColsSubject = subjectFromObs({
    observable: this.controlsSubject
      .pipe(
        filter(Boolean),
        map((controls) => {

          const numOfControls = controls.length || 0;

          if (numOfControls > 4) {
            return 2
          }

          if (numOfControls > 8) {
            return 3;
          }

          return 1;
        })
      )
    ,
    initialValue: 1,
    until: this._destroy
  })

  readonly applyValidationSubject = new BehaviorSubject<boolean>(true)


  constructor() {

    combineLatest([this.formDataSubject, this.mainFormGroupSubject]).pipe(
      filterAllTruthyInTuple(),
      takeUntil(this._destroy)
    )
      .subscribe(([formData, mainFormGroup]) => {


        Object.entries(formData)
          .forEach(([dataField, value]) => {
            const ctrl = mainFormGroup.get(dataField)
            ctrl?.setValue?.(value);
          })
      })
  }


  private _dynamicControlsToFormControls(controls: IControl[]): { [dataField: string]: SSFormControl } {

    const formControlsDict = controls.reduce<{ [dataField: string]: SSFormControl }>((total, control) => ({
      ...total,
      [control.dataField]: new SSFormControl(control)
    }),
      {}
    )

    return formControlsDict;
  }


  private _getMainFormGroup(controls: IControl[]) {

    const formControls = this._dynamicControlsToFormControls(controls)

    const mainFormGroup = new SSFormGroup(formControls);
    Object.values(formControls).forEach((ctrl) => ctrl.formGroup = mainFormGroup)
    Object.entries(formControls).forEach(([dataField, ctrl]) => ctrl.setValue(mainFormGroup.value[dataField]))
    return mainFormGroup;
  }
}
